import { useState } from 'react';
import { HttpResult } from '../../models/API';
import { jsonGet } from '../../utils/http';
import { useEffectAsync } from '../useEffectAsync';
/**
 * @param  {string} url - TODO: add url validator
 * @param  {any[]} inputs - an array of affective variables.
 */
export const useAPI = <T>(url: string, initData: T, inputs: any[], preventRequest: boolean = false): [T, boolean, boolean] => {
    interface TempHttpResult extends HttpResult {
        body: T
    }
    const [data, setData] = useState(initData);
    const [loading, setLoading]: [boolean, any] = useState(true);
    const [error, setError]: [boolean, any] = useState(false);
    useEffectAsync(async () => {
        if (!preventRequest) {
            const res = await jsonGet(url) as TempHttpResult;
            if (res.status === 200 && res.body) {
                setLoading(false);
                setData(res.body);
            } else {
                setError(true);
                setLoading(false);
            }
        }
    }, [...inputs]);
    return [data, loading, error];
};



// WEBPACK FOOTER //
// ./src/hooks/APIs/useAPI.ts